import React from 'react'

export const UserTypes = {
  Admin: 1,
  Sales: 2,
  Maintainer: 3,
  School: 4,
  Teacher: 5,
}

const teacherMenu = [
  {
    path: '/user/info',
    name: '账号信息',
    icon: (
      <svg className="icon" aria-hidden="true">
        <use xlinkHref="#iconUser"></use>
      </svg>
    ),
  },
  // {
  //   path: "/user/collections",
  //   name: "我的收藏",
  //   icon: <svg className='icon' aria-hidden='true'>
  //     <use xlinkHref='#iconRead'></use>
  //   </svg>
  // },
  // {
  //   path: "/user/uploads",
  //   name: "我的上传",
  //   icon: <svg className='icon' aria-hidden='true'>
  //     <use xlinkHref='#iconFile'></use>
  //   </svg>
  // },
  // {
  //   path: "/user/downloads",
  //   name: "我的下载",
  //   icon: <svg className='icon' aria-hidden='true'>
  //     <use xlinkHref='#iconFile'></use>
  //   </svg>
  // },
  // {
  //   path: '/user/messages',
  //   name: '我的消息',
  //   icon: <svg className='icon' aria-hidden='true'>
  //     <use xlinkHref='#iconMessage'></use>
  //   </svg>
  // },
  {
    path: '/user/suggestions',
    name: '使用建议',
    icon: (
      <svg className="icon" aria-hidden="true">
        <use xlinkHref="#iconForm"></use>
      </svg>
    ),
  },
  {
    path: '/user/agree',
    name: '用户协议',
    icon: (
      <svg className="icon" aria-hidden="true">
        <use xlinkHref="#iconForm"></use>
      </svg>
    ),
  },
]

const schoolMenu = [
  {
    path: '/user/info',
    name: '账号信息',
    icon: (
      <svg className="icon" aria-hidden="true">
        <use xlinkHref="#iconUser"></use>
      </svg>
    ),
  },
  {
    path: '/user/teachers',
    name: '教师管理',
    icon: (
      <svg className="icon" aria-hidden="true">
        <use xlinkHref="#icongroup"></use>
      </svg>
    ),
  },
  // {
  //   path: '/user/messages',
  //   name: '消息中心',
  //   icon: <MessageOutlined />,
  // },
  {
    path: '/user/suggestions',
    name: '使用建议',
    icon: (
      <svg className="icon" aria-hidden="true">
        <use xlinkHref="#iconForm"></use>
      </svg>
    ),
  },
  {
    path: '/user/agree',
    name: '用户协议',
    icon: (
      <svg className="icon" aria-hidden="true">
        <use xlinkHref="#iconForm"></use>
      </svg>
    ),
  },
]

export const UserMenuMap = {
  admin: teacherMenu,
  school: schoolMenu,
  teacher: teacherMenu,
  guest: teacherMenu,
  student: teacherMenu
}
